import NavBar from './NavBar';
import UserContainer, { User } from './variants/microservice/User';
import { default as NavBarHelpMenu } from './variants/microservice/HelpMenu';
import NavBarEnvironment from './variants/microservice/Environment';
NavBar.User = UserContainer;
NavBar.UserComponent = User;
NavBar.Environment = NavBarEnvironment;
NavBar.HelpMenu = NavBarHelpMenu;
export default NavBar;